import styled from 'styled-components';
import _default from '../../themes/default';

export const Container = styled.div`
    background: transparent;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 1;
    align-items: center;
`;

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: min(1440px, 100%);
    max-width: 1440px;
    margin: 0 auto;
    padding: 10px 48px 100px;
    box-sizing: border-box;
    gap: 12px;
    @media (max-width: 640px) {
        padding: 10px 16px 72px;
    }
`;

export const Title = styled.h2`
font-size: clamp(28px, 5vw, 42px);
text-align: center;
font-weight: 600;
margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
`;

export const Desc = styled.p`
    font-size: 18px;
    text-align: center;
    max-width: 640px;
    padding: 0 16px;
    color: ${({ theme }) => theme.text_secondary};
    @media (max-width: 768px) {
        margin-top: 12px;
        font-size: 16px;
    }
`;

export const ToggleButtonGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    border: 1.5px solid ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.primary};
    font-size: 16px;
    border-radius: 12px;
    font-weight: 500;
    margin: 22px 16px;
    max-width: calc(100% - 32px);
    @media (max-width: 768px) {
        font-size: 14px;
    }
`

export const ToggleButton = styled.div`
    padding: 8px 18px;
    border-radius: 6px;
    cursor: pointer;
    ${({ $active, theme }) =>
        $active && `
    background: ${theme.primary + 20};
    `
    }
    &:hover {
        background: ${({ theme }) => theme.primary + 8};
    }
    @media (max-width: 768px) {
        padding: 6px 8px;
        border-radius: 4px;
    }
`
export const Divider = styled.div`
    width: 1.5px;
    background: ${({ theme }) => theme.primary};
`


export const CardContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 28px;
    flex-wrap: wrap;
    width: 100%;
    padding: 0 16px 24px;
`;
